import { useEmbarcacaoPropulsao } from "../../../../hooks/use-embarcacao-propulsao";
import { EMPTY_FIELD_PLACEHOLDER, latestAtualizacao } from "../../../detail-format/detail-format";
import { buildDetailFields } from "../../../detail-format/detail-fields";
import type { EmbarcacaoDetailSectionProps } from "../../embarcacao-detail-section";
import {
  PROPULSAO_EMPTY_STATE,
  PROPULSAO_FIELDS,
  PROPULSAO_ID,
  PROPULSAO_LOADING_MESSAGE,
  PROPULSAO_TEST_ID,
  PROPULSAO_TITLE,
} from "./propulsao-section.constants";

/** Seção Propulsão do detalhamento da embarcação: somente leitura, com os campos já formatados para a View. */
export function usePropulsaoSection({
  embarcacaoId,
  onReauthenticate,
}: EmbarcacaoDetailSectionProps) {
  const { status, propulsao, errorMessage, reload } = useEmbarcacaoPropulsao(embarcacaoId);

  return {
    id: PROPULSAO_ID,
    title: PROPULSAO_TITLE,
    testId: PROPULSAO_TEST_ID,
    fieldsTestId: `${PROPULSAO_TEST_ID}-fields`,
    status,
    errorMessage,
    loadingMessage: PROPULSAO_LOADING_MESSAGE,
    emptyContent: PROPULSAO_EMPTY_STATE,
    onReauthenticate,
    onRetry: reload,
    // Só há data de atualização a exibir quando a seção tem dados.
    ultimaAtualizacao: propulsao
      ? latestAtualizacao([propulsao.ultimaAtualizacao, propulsao.atualizacaoPropulsao])
      : undefined,
    fields: buildDetailFields(
      propulsao,
      PROPULSAO_FIELDS,
      PROPULSAO_TEST_ID,
      EMPTY_FIELD_PLACEHOLDER,
    ),
  };
}
